import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import Screening, { PendingAwbs } from '../models/Screening';
import ScreeningReport from '../models/ScreeningReport';
import ScreeningResponse from '../models/ScreeningResponse';
import ScreeningAwbDetails from '../models/ScreeningAwbDetails';
import ScreeningConsignment, { SecurityConsignmentResponse } from '../models/ScreeningConsignment';

const screeningReqHandler = {

  insertScreening: (awbCode: string, awbNumber: string, version: number, screening: Screening, orderNumber?: string): Promise<ApiResponse<number>> => {
    let url = `screening/${awbCode}/${awbNumber}/${version}`;
    
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
  
    return genericApi.post(url, { screening });
  },
  
  updateScreening: (awbCode: string, awbNumber: string, version: number, screening: Screening, orderNumber?: string): Promise<ApiResponse<boolean>> => {
    let url = `screening/${awbCode}/${awbNumber}/${version}`;
    
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
  
    return genericApi.put(url, { screening });
  },
  
  deleteScreening: (awbCode: string, awbNumber: string, version: number, id: number, orderNumber?: string): Promise<ApiResponse<number>> => {
    let url = `screening/${awbCode}/${awbNumber}/${version}/${id}`;
    
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
  
    return genericApi.delete(url);
  },

  getScreeningExemptions: (awbCode: string, awbNumber: string, version: number): Promise<ApiResponse<ScreeningResponse>> => {
    return genericApi.get(`exemptions/${awbCode}/${awbNumber}/${version}`);
  },

  getScreeningMeasures: (): Promise<ApiResponse<Array<string>>> => {
    return genericApi.get(`screening/measures`);
  },

  getScreeningReport: (startDate: string, startTime: string, endDate: string, endTime: string, keyword: string, measures: Array<string>): Promise<ApiResponse<Array<ScreeningReport>>> => {
    const params = new URLSearchParams();
    params.set('measures', JSON.stringify(measures || []));
    if (startDate) {
      params.set('start_date', startDate);
    }
    if (endDate) {
      params.set('end_date', endDate);
    }
    if (startTime) {
      params.set('start_time', startTime);
    }
    if (endTime) {
      params.set('end_time', endTime);
    }
    if (keyword) {
      params.set('keyword', keyword);
    }
    return genericApi.get(`screening/report?${params.toString()}`);
  },
  getScreeningCsv: (startDate: string, startTime: string, endDate: string, endTime: string, keyword: string, flight: string, airline?: string): Promise<ApiResponse<Array<any>>> => {
    const params = new URLSearchParams();
    if (startDate) {
      params.set('start_date', startDate);
    }
    if (endDate) {
      params.set('end_date', endDate);
    }
    if (startTime) {
      params.set('start_time', startTime);
    }
    if (endTime) {
      params.set('end_time', endTime);
    }
    if (keyword) {
      params.set('keyword', keyword);
    }
    if (flight) {
      params.set('flight', flight);
    }
    if (airline) {
      params.set('airline', airline);
    }
    return genericApi.get(`screening/csv?${params.toString()}`);
  },
  getReportByFilter: (flight: string): Promise<ApiResponse<Array<ScreeningReport>>> => {
    let url: string = `screening/flight?flight=${flight}`;
    return genericApi.get(url);
  },
  getScreeningAwb: (awbCode: string, awbNumber: string, version: number, orderNumber?: string): Promise<ApiResponse<ScreeningAwbDetails>> => {
    let url = `awb/${awbCode}/${awbNumber}/${version}/screening`;
    
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
  
    return genericApi.get(url);
  },
  getScreeningConsignment: (awbCode: string, awbNumber: string, version: number, orderNumber?: string): Promise<ApiResponse<SecurityConsignmentResponse>> => {
    let url = `screening_consignment/${awbCode}/${awbNumber}/${version}`;
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
    return genericApi.get(url);
  },
  saveScreeningConsignment: (awbCode: string, awbNumber: string, version: number, consignment: ScreeningConsignment): Promise<ApiResponse<number>> => {

    return genericApi.put(`screening_consignment/${awbCode}/${awbNumber}/${version}`, { consignment });
  },
  emailScreeningConsignment: (awbCode: string, awbNumber: string, version: number, orderNumber?: string): Promise<ApiResponse<boolean>> => {
    let url = `screening_consignment/${awbCode}/${awbNumber}/${version}/email`;
    if (orderNumber) {
      url += `?orderNumber=${orderNumber}`;
    }
    return genericApi.get(url);
  },
  getPendingAwbs: (date: string): Promise<ApiResponse<Array<PendingAwbs>>> => {
    return genericApi.get(`screenings?date=${date}`);
  },
}

export default screeningReqHandler;